<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <!-- && !system_setting.isAutoSubmitOrderToPriceMonitor -->
          <el-button v-if="tableAcl.indexOf('Push') != -1" type="primary" class="btn primary" @click="push">确认上传</el-button>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset1"></SelectFilter>
        </div>
      </div>
      <!-- row-key="id"  -->
      <el-table ref="multipleTable" border v-loading="loading" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset1">恢复默认</div>
          </div>
        </template>
        <!-- :reserve-selection="true" -->
        <el-table-column fixed prop="selection" type="selection" width="55" align="center"></el-table-column>
        <el-table-column fixed type="index" width="55" align="center"></el-table-column>
        <el-table-column prop="priceMonitorHospitalId" width="120" label="医院编号" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorHospitalId?scope.row.priceMonitorHospitalId:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="no" width="170" label="院退货单号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="date" label="退货日期" width="150">
          <template slot-scope="scope">
            {{ scope.row.date ? parseTime(new Date(scope.row.date), "{y}-{m}-{d}") : "" }}
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" width="150" label="创建时间" show-overflow-tooltip>
          <template slot-scope="scope">{{
            parseTime(new Date(scope.row.createdTime))
          }}</template>
        </el-table-column>

        <el-table-column prop="detailId" width="170" label="院退货明细编号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="priceMonitorReagentCompanyIdPs" width="140" label="配送企业编码" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorReagentCompanyIdPs?scope.row.priceMonitorReagentCompanyIdPs:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="supplierName" width="120" label="配送企业名称" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.supplierName?scope.row.supplierName:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="goodsId" width="120" label="平台产品id" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.goodsId?scope.row.goodsId:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="supplierProductNo" width="140" show-overflow-tooltip label="院目录编码">
          <template slot-scope="scope">
            {{ scope.row.supplierProductNo?scope.row.supplierProductNo:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="productName" width="120" label="院产品名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="specName" width="120" label="院规格型号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="manufacturerName" width="120" label="院生产厂家" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productRegistCertNo" width="120" label="院注册证号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="batch" width="170" label="批号" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.batch?scope.row.batch:'-' }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="manufactureDate" label="生产日期" width="100">
          <template slot-scope="scope">
            {{scope.row.manufactureDate ? parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}") : ""}}
          </template>
        </el-table-column> -->
        <el-table-column prop="validityDate" label="有效期" width="100">
          <template slot-scope="scope">
            {{
              scope.row.validityDate
                ? parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}")
                : "-"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="priceMonitorReturnTypeName" width="120" label="平台退货类型" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorReturnTypeName?scope.row.priceMonitorReturnTypeName:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="minUnit" width="100" label="单位" show-overflow-tooltip></el-table-column>
        <el-table-column prop="price" width="100" label="退货单价" show-overflow-tooltip></el-table-column>
        <el-table-column prop="number" width="120" label="退货数量"></el-table-column>
        <el-table-column prop="priceMonitorReturnReason" width="170" label="退货原因" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorReturnReason?scope.row.priceMonitorReturnReason:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="priceMonitorReturnPayTypeName" width="170" label="支付方式" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorReturnPayTypeName?scope.row.priceMonitorReturnPayTypeName:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="priceMonitorDistributionId" width="140" label="平台配送明细编号" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorDistributionId?scope.row.priceMonitorDistributionId:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="priceMonitorId" width="140" label="平台退货明细编号" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorId?scope.row.priceMonitorId:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="priceMonitorReturnResponseTime" width="150" label="退货响应时间" show-overflow-tooltip>
          <template slot-scope="scope">{{
            parseTime(new Date(scope.row.priceMonitorReturnResponseTime))
          }}</template>
        </el-table-column>
        <el-table-column prop="ownerDeptName" width="140" label="退货科室" show-overflow-tooltip></el-table-column>
        <el-table-column prop="priceMonitorWarehouseTime" width="150" label="收货时间" show-overflow-tooltip>
          <template slot-scope="scope">{{
            scope.row.priceMonitorWarehouseTime?
            parseTime(new Date(scope.row.priceMonitorWarehouseTime)):'-'
          }}</template>
        </el-table-column>
        <el-table-column prop="priceMonitorWarehousePerson" width="140" label="收货人" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorWarehousePerson?scope.row.priceMonitorWarehousePerson:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="priceMonitorWarehouseCount" width="140" label="收货数量" show-overflow-tooltip></el-table-column>
        <el-table-column prop="priceMonitorDistributeCount" width="140" label="配送数量" show-overflow-tooltip></el-table-column>
        <el-table-column prop="priceMonitorDistributeTime" width="140" label="配送时间" show-overflow-tooltip>
          <template slot-scope="scope">{{
            scope.row.priceMonitorDistributeTime?
            parseTime(new Date(scope.row.priceMonitorDistributeTime)):'-'
          }}</template>
        </el-table-column>
        <el-table-column prop="priceMonitorOrderName" width="140" label="平台订单名称" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorOrderName?scope.row.priceMonitorOrderName:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="priceMonitorRefuseReason" width="140" label="拒绝原因" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorRefuseReason?scope.row.priceMonitorRefuseReason:'-' }}
          </template>
        </el-table-column>

        <el-table-column prop="priceMonitorIsResponseName" width="140" label="退货处理状态" show-overflow-tooltip></el-table-column>
        <el-table-column prop="priceMonitorReturnInvoiceId" width="140" label="发票号" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorReturnInvoiceId?scope.row.priceMonitorReturnInvoiceId:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="priceMonitorReturnMaintenanceInvoiceTime" width="140" label="维护发票时间" show-overflow-tooltip>
          <template slot-scope="scope">{{
            scope.row.priceMonitorReturnMaintenanceInvoiceTime?
            parseTime(new Date(scope.row.priceMonitorReturnMaintenanceInvoiceTime)):'-'
          }}</template>
        </el-table-column>
        <el-table-column prop="priceMonitorStateName" width="100" label="数据状态" show-overflow-tooltip></el-table-column>
        <el-table-column prop="supplierProductCompareStateName" width="100" label="对照状态" show-overflow-tooltip></el-table-column>
        <el-table-column fixed="right" prop="priceStateName" width="100" label="价格状态" show-overflow-tooltip>
          <template slot-scope="scope"><span :class="{
                enable: scope.row.priceState == 1,
                forbidden: scope.row.priceState == 0,
              }">{{ scope.row.priceStateName }}</span></template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { GetPurchaseOutStockDetails, PushPurchaseOutStockDetails } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import BaseListMixin from "@/mixin/baseList-mixin.js";
import {
  PriceMonitorOrderTypeOptions,
  PriceMonitorPushStateOptions,
  PriceMonitorCompareStateOptions,
  PriceMonitorPriceStateOptions,
  PriceMonitorOrderStateOptions,
  PriceMonitorReturnStateOptions,
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      GetDatasAction: GetPurchaseOutStockDetails,

      PriceMonitorOrderTypeOptions: PriceMonitorOrderTypeOptions,
      PriceMonitorPriceStateOptions: PriceMonitorPriceStateOptions,
      PriceMonitorCompareStateOptions: PriceMonitorCompareStateOptions,
      PriceMonitorPushStateOptions: PriceMonitorPushStateOptions,
      PriceMonitorOrderStateOptions: PriceMonitorOrderStateOptions,
      PriceMonitorReturnStateOptions: PriceMonitorReturnStateOptions,
      filterOptions: [
        {
          name: "院退货单",
          type: "input",
          code: "keyWord",
        },
        {
          name: "平台产品ID",
          type: "input",
          code: "goodsId",
        },
        {
          name: "院目录编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "院产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "院规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "配送企业编码",
          type: "input",
          code: "companyIdPs",
        },
        {
          name: "配送企业名称",
          type: "input",
          code: "companyName",
        },
        {
          name: "院生产厂家",
          type: "input",
          code: "manufacturerName",
        },
        {
          name: "批号",
          type: "input",
          code: "batch",
        },
        {
          name: "院退货单价",
          type: "number",
          code: "price",
        },
        {
          name: "平台订单名称",
          type: "input",
          code: "priceMonitorOrderName",
        },
        {
          name: "注册证号",
          type: "input",
          code: "productRegistCertNo",
        },
        {
          name: "创建时间",
          type: "date",
          code: "date",
          defaultValue: this.getDefaultDateRange(), // [new Date(new Date().setDate(new Date().getDate() - 7)), new Date()],//],
          startDateCode: "startDate",
          endDateCode: "endDate",
        },
        {
          name: "退货处理状态",
          type: "select",
          code: "isResponse",
          data: PriceMonitorReturnStateOptions,
        },
        {
          name: "发票号",
          type: "input",
          code: "returnInvoiceId",
        },
        {
          name: "目录对照状态",
          type: "select",
          code: "supplierProductCompareState",
          data: PriceMonitorCompareStateOptions,
          defaultValue: 1,
        },
      ],
    };
  },
  methods: {
    getDefaultDateRange () {
      var endDate = new Date();
      var start = new Date(new Date().setDate(new Date().getDate() - 6));
      // 开始日期转换为00:00:00
      var startDate = new Date(
        `${start.getFullYear()}-${start.getMonth() + 1}-${start.getDate()} 00:00:00`
      );

      return [startDate, endDate];
    },

    push () {
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        this.$my_message("请选择要上传的退货明细数据", "warning");
        return;
      }

      // if (this.multipleSelection.length != 1) {
      //   this.$my_message('请只选择一条数据上传', 'warning');
      //   return;
      // }

      var pushedList = this.multipleSelection.filter((e) => e.priceMonitorState == 1);
      if (pushedList && pushedList.length > 0) {
        this.$my_message("请选择要未上传的退货明细数据", "warning");
        return;
      }

      // 未对照的不能上传
      let notCompareList = this.multipleSelection.filter(
        (item) => item.supplierProductCompareState != 1
      );
      if (notCompareList && notCompareList.length > 0) {
        this.$my_message(
          `所选退货单明细中包含供货目录未对照的明细，请对照后再上传`,
          "warning"
        );
        // this.$my_message(`所选医院验收入库单号${notCompareList[0].no}存在价格异常，请核对后确认是否上传`, 'warning');
        return;
      }

      // 价格异常的提示
      let priceExceptionList = this.multipleSelection.filter(
        (item) => item.priceState != 1
      );
      if (priceExceptionList && priceExceptionList.length > 0) {
        const h = this.$createElement;
        let content = [h("p", "以下所选退货单明细存在价格异常")];
        priceExceptionList.forEach((item) => {
          content.push(h("p", { style: "color:red" }, `${item.no}`));
        });
        content.push(h("p", "请核对后确认是否上传"));
        this.$confirm("提示", {
          title: "提示",
          type: "warning",
          message: h("div", content),
        }).then(() => {
          // 上传订单
          this.pushOrder();
        });
      } else {
        this.pushOrder();
      }
    },
    pushOrder () {
      let ids = this.multipleSelection.map((item) => item.detailId);
      PushPurchaseOutStockDetails({ ids: ids }).then((res) => {
        var notNeedPushCount = res.returnData.notNeedPushCount;
        var successCount = res.returnData.successCount;
        var failedCount = res.returnData.failedCount;
        var failedMessageDic = res.returnData.failedMessageDic;
        var message = `上传成功${successCount}条;\n`;
        message += `上传失败${failedCount}条;\n`;
        message += `${notNeedPushCount}条不需要上传;\n`;
        if (failedMessageDic) {
          message += `错误详情：`;
          for (let key in failedMessageDic) {
            message += `明细编码：${key},异常信息:${failedMessageDic[key]};`;
          }
        }

        this.ids = [];
        this.multipleSelection = [];

        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.clearSelection();
        }

        this.$my_message(message, "success");
        // this.$my_message('上传成功', 'success');
        this.getData();
      });
    },
    // 重置
    reset1 () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        priceMonitorType: 1,
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = [];
      this.multipleSelection = [];

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.loading = true;
      this.getData();
    },
  },
  mounted () { },
  created () {
    var dateArr = this.getDefaultDateRange();
    this.query.startDate = this.parseTime(dateArr[0]);
    this.query.endDate = this.parseTime(dateArr[1]);
    this.query.priceMonitorType = 1;
  },
};
</script>

<style lang="scss" scoped></style>
